// extracted by mini-css-extract-plugin
module.exports = {"container":"home-views_container__e-ENi","title":"home-views_title__1-0UZ","image":"home-views_image__1FF_i"};